import { PageWrapper } from "components";
import HostFormView from "./HostFormView";

export const HostFormContainer = () => {
  return (
    <PageWrapper>
      <HostFormView />
    </PageWrapper>
  );
};
